export const GP_URL = 'https://play.google.com/store/apps/details?id=com.n7mobile.mukoapp';
export const AP_URL = 'https://apps.apple.com/us/app/id1534175036';